var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkasmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 51.808,
    viewBox: "0 0 72 51.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2295097647440",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M8.4,1A7.47,7.47,0,0,0,1,8.4v35a7.47,7.47,0,0,0,7.4,7.4H64.269c4.038,0,6.731-3.365,6.731-7.4V8.4C71,4.365,68.308,1,64.269,1Z",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    d: "M22.34.454,0,22.885",
    transform: "translate(2.692 24.231)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-3",
    x1: 27.596,
    y2: 25.577,
    transform: "translate(40.385 2.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M68,37v.673L90.885,59.885",
    transform: "translate(-22.904 -12.769)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-3",
    x1: 27.596,
    y1: 25.577,
    transform: "translate(2.019 2.692)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.038,
    cy: 4.038,
    r: 4.038,
    transform: "translate(30.962 27.596)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkasmail);
export default __webpack_public_path__ + "static/media/okasmail.f7143c9a031f95890cd1c0b98cc742bd.svg";
export { ForwardRef as ReactComponent };